//  components/Categoria.js 
import React from 'react';
import CategoriaContainer from './categoria/CategoriaContainer'; 


const Categoria = (props) => {
  return <CategoriaContainer {...props} />;
};

export default Categoria;